import React from "react";

interface ViewEventCardProps {
  cardData: {
    title: string;
    value: string;
  }[];
  className?: string;
}

export const ViewEventCard = ({ cardData, className }: ViewEventCardProps) => {
  return (
    <div
      className={`grid grid-cols-1 space-y-8 md:space-y-0  md:grid-cols-2 ${className}`}
    >
      {cardData.map((item: any, index) => (
        <div
          key={index}
          className={`flex justify-between md:grid md:grid-cols-2 ${
            index % 2 == 0 ? "md:border-r md:pr-[10px]" : "md:pl-5"
          } ${
            index === cardData?.length - 1 ||
            (index === cardData?.length - 2 && index % 2 == 0)
              ? ""
              : "md:border-b"
          }   md:py-7`}
        >
          <p className="font-openSans  font-bold max-w-[120px] mobile:max-w-full text-web-body-sm lg:text-web-body-md lg:leading-5 leading-4 text-brand-textLightGrey">
            {item?.title}
          </p>
          <p className="font-openSans font-normal text-left  md:text-left max-w-[140px] break-words  mobile:max-w-[200px] sm:max-w-[340px] md:max-w-full  text-web-body-sm lg:text-web-body-md leading-4 lg:leading-5 text-brand-textLightGrey">
            {item?.value}
          </p>
        </div>
      ))}
    </div>
  );
};

export default ViewEventCard;
